import type { RouterOutputs } from "@/types/rpc";
import { formatCountry } from "@garimpa/lib/countries";

type Artist = RouterOutputs["music"]["searchArtists"]["artists"][number];

export function artistResultMetadata(
  artist: Artist,
  locale: string,
  formatStyleOrGenre: (value: string) => string,
) {
  const normalizedName = artist.name.trim().toLowerCase();
  const normalizedRealname = artist.realname?.trim().toLowerCase();
  const countryName = formatCountry(artist.country ?? null, locale);
  const primaryStyleOrGenre = artist.primaryStyleOrGenre?.trim();
  return {
    countryName,
    primaryStyleOrGenreLabel: primaryStyleOrGenre ? formatStyleOrGenre(primaryStyleOrGenre) : null,
    showCountry: Boolean(countryName),
    showRealname: Boolean(artist.realname && normalizedRealname !== normalizedName),
    showPrimaryStyleOrGenre: Boolean(primaryStyleOrGenre),
  };
}
